import { render } from "./ScanHistory.vue?vue&type=template&id=f5ef4442&scoped=true"
import script from "./ScanHistory.vue?vue&type=script&lang=js"
export * from "./ScanHistory.vue?vue&type=script&lang=js"

import "./ScanHistory.vue?vue&type=style&index=0&id=f5ef4442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ef4442"]])

export default __exports__